import React from 'react';
import styled from 'styled-components';
import NormalBtn from '../button/NormalBtn';
import IconBtn from '../button/IconBtn';
import CustomTitle from '../title/CustomTitle';
import NormalInput from '../input/NormalInput';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changePwAction, changeMyPwAction, resetStatusAction, resetChangeStatusAction } from '../../../modules/su/userCheckModule';
import { useEffect } from 'react';
import { useRef } from 'react';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../popup/NormalPopup';
import NormalPopupOneBtn from './NormalPopupOneBtn';

/**
 * Modal 팝업 안에 들어가는 일반 팝업 
 */
const MySettingPwPopupBlock = styled.div` 
    width: 330px;
    height: 100%;
    border-radius: 10px;
`;

const MyPwContentsBlock = styled.div`
    //width: 97%;
    height: ${props => props.height || '97%'};//97%;
    background-color:#fff;
    border-radius: 10px;
    padding: 30px 30px 30px 30px;
    text-align: center;
`;

const MyPwCloseIconBlock = styled.img`
    display: ${props => props.display || 'none'};
    position: absolute;
    top: 40px;
    right: 5px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    src:${(props) => (props.src)};
`;

const MyPwTitleContainerBlock = styled.div`
    //margin: 20px auto;
    margin: 10px 0px 30px 0px;
    text-align: center;
    height: '50%';
    width: '90%';
`;

const MyPwBtnContainerBlock = styled.div`
    //position: absolute;
    //bottom: 65px;
    text-align: center;
    margin: 40px 45px 0px 45px;
    width: 180px;
    float: ${props => props.float || 'left'};
`;

const MyPwPopupBtnBlock = styled.div`
    width: 180px;
    height: 40px;
    display: inline-block;
`;

const MyPwPopupButtonBlock = styled.button`
    pointer-events: ${props => props.disable};
    background-color: ${props => props.colorF};
    border: 1px solid ${props => props.colorF};
    width : 182px ;
    height: 40px;
    font-size : 14x; 
    display : inline-block;
    border-radius: 20px; 
    color: #fff;
    font-weight : 300;
`;

export const MySettingModalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '10%',
        transform: 'translate(-50%, -50%)',
        zIndex: '999',
        overlay: 'auto',
        WebkitOverflowScrolling: 'touch',
        //width: "330px",
        minHeight: "415px",
        borderRadius: '0px',
        backgroundColor: 'transparent',
        borderWidth: '0px',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: '1000'
    },
};

const MySettingPwPopup = ({ isIconShow, text, txtBtn, onClickIcon }) => {

    const dispatch = useDispatch();

    //const inputRef = useRef([React.createRef(), React.createRef(), React.createRef()]);
    const [openModal, setOpenModal] = useState(false);
    const [msg, setMsg] = useState("");
    const [msg2, setMsg2] = useState("");
    const [passwd, setPassWd] = useState(null);
    const [passwdErr, setPasswdErr] = useState(false);
    const [passwdErrTxt, setPasswdErrTxt] = useState("!기존 비밀번호를 정확하게 입력해주세요.");

    const [newPasswd, setNewPasswd] = useState(null);
    const [newPasswdErr, setNewPasswdErr] = useState(false);
    const [newPasswdErrTxt, setNewPasswdErrTxt] = useState("!6자-20자 이내의 영문+숫자+특수문자의 조합으로 입력해주세요.");

    const [passwdConfirm, setPasswdConfirm] = useState(null);
    const [passwdConfirmErr, setPasswdComfirmErr] = useState(false);
    const [passwdConfirmErrTxt, setPasswdConfrimErrTxt] = useState("!입력하신 비밀번호와 동일하게 입력해주세요.");

    const boxRef = useRef(null);
    const bottonRef = useRef(null);
    const [heightBox, setHeightBox] = useState(415);
    const [changePW, setChangePW] = useState(false);
    const inputPw = useRef(null);
    const inputNPw = useRef(null);
    const inputCPw = useRef(null);

    const { checkStatus, loading, changeStatus, accessToken, message } = useSelector(
        ({ userCheckReducer, loadingReducer, userReducer }) => ({
            loading: loadingReducer['user/CHECK'],
            changeStatus: userCheckReducer.changeStatus,
            accessToken: userReducer.accessToken,
            checkStatus: userCheckReducer.checkStatus,
            message: userCheckReducer.message
        })
    );

    useEffect(() => {

        // 변경 완료시 팝업 닫기 
        if (changeStatus !== null) {

            if (changeStatus === 200) {
                setMsg("비밀번호가 정상적으로 변경되었습니다.");
                setMsg2("")
                setOpenModal(true);
                setChangePW(true)
            } else {
                //setPasswdErr(true);
                //setPasswdErrTxt(message);
                setMsg(message);
                setMsg2("")
                setOpenModal(true);
                dispatch(resetChangeStatusAction());
                setChangePW(false)
            }
        }
    }, [changeStatus])

    const handlePwChange = () => {
        if (!newPasswdErr && !passwdConfirmErr) {
            dispatch(changeMyPwAction(accessToken, passwd, newPasswd));
        }
    }

    const handleIconClose = () => {
        setMsg("비밀번호 변경중입니다.\n닫으시겠습니까?");
        setMsg2("닫으시겠습니까?");
        setOpenModal(true);
    }

    const handlePasswdInput = (e) => {
        setPassWd(e.target.value);
        setPasswdErr(false);
    }

    const handleNewPasswdInput = (e) => {
        setNewPasswd(e.target.value);
        let valid = !validatePassword(e.target.value);
        if (valid) {
            setNewPasswdErrTxt("!6자-20자 이내의 영문+숫자+특수문자의 조합으로 입력해주세요.")
        }
        setNewPasswdErr(valid);
    }

    const handlePasswdConfirmInput = (e) => {
        setPasswdConfirm(e.target.value);
        setPasswdComfirmErr(newPasswd !== e.target.value);
        if (newPasswd !== e.target.value) {
            setPasswdConfrimErrTxt("!입력하신 비밀번호가 맞지 않습니다.\n다시 한번 확인해주세요.");
        }
    }

    const validatePassword = (value) => {
        var regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?=+\(\)\.\-&])[A-Za-z\d$@$!%*#?=+\(\)\.\-&]{6,20}$/;
        if (value === null) return false;
        return regex.test(value);
    }

    const handleModalClose = () => {
        setOpenModal(false);
    }

    const handleModalBtn1Click = () => {
        setOpenModal(false);
        onClickIcon();
    }

    const handleModalBtn2Click = () => {
        setOpenModal(false);
    }

    const handleOneBtnPopupClick = () => {
        setOpenModal(false);

        if(changePW){
            onClickIcon();
            dispatch(resetStatusAction());
        }
        else {
            if(inputPw.current) {
                inputPw.current.value = "";
                setPassWd("");
            }
            
            if(inputNPw.current) {
                inputNPw.current.value = "";
                setNewPasswd("");
            }

            if(inputCPw.current) {
                inputCPw.current.value = "";
                setPasswdConfirm("");
            }
        }
        
    }

    useEffect(() => {

        // 변경 완료시 팝업 닫기 
        if (bottonRef.current !== null && boxRef.current !== null) {
            let boxY = boxRef.current.getBoundingClientRect().top;
            let boxH = boxRef.current.getBoundingClientRect().height;
            let bottonY = bottonRef.current.getBoundingClientRect().top;
            let bottonH = bottonRef.current.getBoundingClientRect().height;
            if((boxY + boxH) - (bottonY + bottonH)  < 31 ){
                //console.log("height = " + heightBox);
                let height = heightBox + 31 - ((boxY + boxH) - (bottonY + bottonH) );
                //console.log("height2 = " + height);
                setHeightBox(height);
            }else{
                //console.log("height3 = " + heightBox);
                let height = heightBox - (((boxY + boxH) - (bottonY + bottonH) ) - 31);
                //console.log("height4 = " + height);
                setHeightBox(height);
            }
            
        }
    }, [passwdErr,newPasswdErr, passwdConfirmErr])

    const isDiableSubmit = () => {

        if (passwd && passwd.length > 0 && newPasswd && newPasswd.length > 0 && passwdConfirm && passwdConfirm.length > 0 && !newPasswdErr && !passwdConfirmErr) {
            return false;
        }
        return true;

    }

    return (
        <MySettingPwPopupBlock>
            <MyPwContentsBlock ref = {boxRef} height = {heightBox+'px'}>
                <MyPwCloseIconBlock
                    display={isIconShow ? 'block' : 'none'}
                    onClick={handleIconClose}
                    src="/assets/images/icon/close_icon.png"
                />

                <MyPwTitleContainerBlock >
                    <CustomTitle
                        title={text} textColor="#111"
                        fontSize="18px" fontWeight='500'
                        marginTop="10px" textAlign="center"
                        marginBottom="5px" />
                </MyPwTitleContainerBlock>

                <NormalInput
                    inputRef={inputPw}
                    type='password'
                    maxLength='20'
                    placeholder='기존 비밀번호를 입력해주세요.'
                    //marginBottom='10px'
                    fontSize='12px'
                    errFontSize='10px'
                    errHeight='60px'
                    onChange={handlePasswdInput}
                    onFoucs={() => { setPasswdErr(!validatePassword(passwd)); }}
                    onBlur={() => { setPasswdErr(!validatePassword(passwd)); }}
                    dispError={passwdErr}
                    errText={passwdErrTxt} />

                <NormalInput
                    inputRef={inputNPw}
                    type='password'
                    maxLength='20'
                    fontSize='12px'
                    errFontSize='10px'
                    errHeight='80px'
                    placeholder='새 비밀번호 입력해 주세요.'
                    //marginBottom='10px'
                    marginTop = '30px'
                    onChange={handleNewPasswdInput}
                    onFoucs={() => { setNewPasswdErr(!validatePassword(newPasswd)); }}
                    onBlur={() => { setNewPasswdErr(!validatePassword(newPasswd)); }}
                    dispError={newPasswdErr}
                    errText={newPasswdErrTxt} />

                <NormalInput
                    inputRef={inputCPw}
                    type='password'
                    maxLength='20'
                    fontSize='12px'
                    errFontSize='10px'
                    errHeight='80px'
                    placeholder='새 비밀번호를 한번 더 입력해 주세요.'
                    marginBottom='10px'
                    marginTop = '10px'
                    onFoucs={() => { setPasswdComfirmErr(newPasswd !== passwdConfirm); }}
                    onBlur={() => { setPasswdComfirmErr(newPasswd !== passwdConfirm); }}
                    onChange={handlePasswdConfirmInput}
                    dispError={passwdConfirmErr}
                    errText={passwdConfirmErrTxt} />

                <MyPwBtnContainerBlock ref = {bottonRef}>
                    <MyPwPopupBtnBlock marginRight='10px' marginLeft='10px'>
                        <MyPwPopupButtonBlock disable={isDiableSubmit() ? "none" : ""} colorF={isDiableSubmit() ? "#e0e0e0" : "#111"} 
                        onClick={handlePwChange} >
                        {txtBtn}
                        </MyPwPopupButtonBlock>
                        {/* <NormalBtn text={txtBtn}
                            width="182px" height="40px"
                            fontSize="14x" display="inline-block"
                            borderRadius="20px" textColor="#fff"
                            onClick={handlePwChange} bgColor="#111" fontWeight="300"
                        /> */}
                    </MyPwPopupBtnBlock>
                </MyPwBtnContainerBlock>

            </MyPwContentsBlock>
            <Modal
                isOpen={openModal}
                onRequestClose={handleModalClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {
                    msg2 === "" ?
                        <NormalPopupOneBtn
                            text=""
                            text2={msg} text3=""
                            btn="확인" onClick={handleOneBtnPopupClick} /> :
                        <NormalPopup
                            text=""
                            text2={msg}
                            text3=""
                            btn1="확인" btn2="취소"
                            onClick1={handleModalBtn1Click}
                            onClick2={handleModalBtn2Click} />
                }

            </Modal>

        </MySettingPwPopupBlock>
    );
};

export default MySettingPwPopup;